import generateAppConfig from './generateAppConfig';
import createExternalLink from './createExternalLink';

// Import your App's config file here
import schoolManagementConfig from '../SchoolManagement/config';
import communityFreeConfig from '../CommunityFree/config';
import transactionsAppConfig from '../Transactions/config';
import maskAppConfig from '../Masquerade/config';
import maskedAsAppConfig from '../Masquerade/maskedAsConfig';
import flyerManagerAppConfig from '../FlyerManager/config';
import nonStopFlyersAppConfig from '../NonStopFlyers/config';
import globalSearchAppConfig from '../GlobalSearch/config';

const dataReportingConfig = createExternalLink(
  'Data & Reporting',
  '/data-reporting',
  'https://sites.google.com/peachjar.com/dataandreporting',
  true,
  true
);

const geminiProConfig = createExternalLink(
  'Gemini Pro',
  '/gemini-pro',
  'https://gemini.google.com/app',
  true,
  true
);

// Register new apps here
export const { apps, sidebarSections } = generateAppConfig([
  {
    sectionLabel: 'Main',
    apps: [
      globalSearchAppConfig,
      schoolManagementConfig,
      transactionsAppConfig,
      maskedAsAppConfig,
      maskAppConfig,
      communityFreeConfig,
      nonStopFlyersAppConfig,
      flyerManagerAppConfig,
      dataReportingConfig,
      geminiProConfig,
    ],
  },
]);
